import { inject, InjectionToken, provideAppInitializer, EnvironmentProviders } from '@angular/core';

// Define a generic interface for the icon registry
export interface IconRegistryInterface {
  registerIcons(icons: unknown[]): void;
}

export async function registerBaseIcons(iconRegistry: IconRegistryInterface): Promise<void> {
  const { mgcIconsBaseSet } = await import('./mgcIcons-base-set');
  iconRegistry.registerIcons(mgcIconsBaseSet);
}

/**
 * Provides an app initializer that registers the base MGC icon set.
 * Accepts an IconRegistry injection token to avoid circular dependencies.
 */
export function provideRegisterBaseIcons(IconRegistryToken: InjectionToken<IconRegistryInterface>): EnvironmentProviders {
  return provideAppInitializer(() => {
    const iconRegistry = inject(IconRegistryToken);
    return registerBaseIcons(iconRegistry);
  });
}
